module.exports = "pegasus/assets/styleGroup2.png";